import CommonDialog, { CommonDialogProps } from 'components/modals/CommonDialog'
import { FC, PropsWithChildren } from 'react'
import { ButtonLoader, ButtonLoaderProps } from '@wellesley/ui'

type TButton = ButtonLoaderProps & { title: string }

type TConfirmModal = PropsWithChildren<
  CommonDialogProps & {
    open: boolean
    title: string
    leftButton: TButton
    rightButton?: TButton
    onClose?(): void
    titleTestId?: string
  }
>

const ConfirmModal: FC<TConfirmModal> = ({
  open,
  title,
  children,
  leftButton,
  rightButton,
  onClose,
  titleTestId,
  ...props
}) => (
  <CommonDialog
    open={open}
    onCloseModal={onClose}
    showClose={false}
    className="gap-none max-w-[400px] rounded-lg"
    {...props}
  >
    <h3
      className="p-none mb-xxs text-center text-lg font-semibold text-gray-700"
      data-testid={titleTestId}
    >
      {title}
    </h3>
    {children && (
      <div className="text-center text-base text-gray-500">{children}</div>
    )}
    <div className="mt-m max-md:gap-s md:gap-m flex justify-center">
      <ButtonLoader
        size="m"
        variant="secondary"
        className="flex-1"
        data-testid="confirm-modal-left-button"
        {...leftButton}
        title={undefined}
      >
        {leftButton.title}
      </ButtonLoader>
      {rightButton && (
        <ButtonLoader
          size="m"
          className="flex-1"
          data-testid="confirm-modal-right-button"
          {...rightButton}
          title={undefined}
        >
          {rightButton.title}
        </ButtonLoader>
      )}
    </div>
  </CommonDialog>
)

export default ConfirmModal
